import React from "react";
import { PowerBiDashboard } from "../components";
import { WithFeatureFlag } from "us.common/components";
import { FeatureFlags } from "us.common/constants";

export default () => {
  return (
    <WithFeatureFlag
      flag={FeatureFlags.POWER_BI_DASHBOARD}
      children={<PowerBiDashboard />}
    />
  );
};
